import React from "react";
import "../../assets/css/seller-add-products.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import { detail_order_img, product_inventory } from "../../constants";
import { useEffect } from "react";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";
import Select, { StylesConfig } from "react-select";

const Seller_add_product = () => {
	const colourOptions = [
		{ value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
		{ value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
		{ value: "purple", label: "Purple", color: "#5243AA" },
		{ value: "red", label: "Red", color: "#FF5630", isFixed: true },
		{ value: "orange", label: "Orange", color: "#FF8B00" },
		{ value: "yellow", label: "Yellow", color: "#FFC400" },
		{ value: "green", label: "Green", color: "#36B37E" },
		{ value: "forest", label: "Forest", color: "#00875A" },
		{ value: "slate", label: "Slate", color: "#253858" },
		{ value: "silver", label: "Silver", color: "#666666" },
	];
	const dot = (color = "green") => ({
		alignItems: "center",
		display: "flex",
	});

	const colourStyles = {
		control: (styles) => ({
			...styles,
			backgroundColor: "transparent",
			minHeight: "45px",
			Height: "auto",
		}),
		option: (styles, { data, isDisabled, isFocused, isSelected }) => {
			return {
				...styles,
				backgroundColor: isDisabled
					? undefined
					: isSelected
					? data.color
					: isFocused
					? "#71966d"
					: undefined,
				Color: isSelected ? undefined : "#71966d",
			};
		},
		input: (styles) => ({ ...styles, ...dot() }),
	};
	// Seller Add Product Js First
	function updateList() {
		var input = document.getElementById("attachments");
		var output = document.getElementById("fileList");
		var children = "";
		for (var i = 0; i < input.files.length; ++i) {
			children +=
				"<li>" +
				input.files.item(i).name +
				'<span className="remove-list" onclick="return this.parentNode.remove()">X</span>' +
				"</li>";
		}
		output.innerHTML = children;
	}
	// Seller Add Product Js First

	// Seller Add Product Js Second
	function updateListtwo() {
		var inputtwo = document.getElementById("attachments-two");
		var outputtwo = document.getElementById("fileList-two");
		var childrentwo = "";
		for (var i = 0; i < inputtwo.files.length; ++i) {
			childrentwo +=
				"<li>" +
				inputtwo.files.item(i).name +
				'<span className="remove-list" onclick="return this.parentNode.remove()">X</span>' +
				"</li>";
		}
		outputtwo.innerHTML = childrentwo;
	}
	// Seller Add Product Js Second

	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
						</div>
						<div className="col-lg-8">
							<div className="products_adding">
								<div className="heading_wrapper">
									<h3>Add New Products</h3>
								</div>
								<form action="">
									<div className="row">
										<div className="col-md-12">
											<div className="form-group">
												<label htmlFor="general_info">Product Name/Title</label>
												<input
													type="text"
													className="form-control"
													id="general_info"
													placeholder="Product"
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label htmlFor="select_category">
													Select categories{" "}
												</label>
												<select id="select_category" className="form-control">
													<option selected>Select categories </option>
													<option>Mobile</option>
													<option>Tablet</option>
													<option>Accessories</option>
												</select>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label htmlFor="sub_category">Variation</label>
												{/* <select id="sub_category" className="form-control">
													<option selected>Color Variation</option>
													<option>Color Variation</option>
													<option>Color Variation</option>
													<option>Color Variation</option>
												</select> */}
												<Select
													// defaultValue={[colourOptions[2], colourOptions[3]]}
													isMulti
													name="colors"
													options={colourOptions}
													className="basic-multi-select"
													classNamePrefix="select"
													styles={colourStyles}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label htmlFor="sub_category">
													Select Sub-categories
												</label>
												<select id="sub_category" className="form-control">
													<option selected>Select Sub-categories </option>
													<option>Select Sub-categories </option>
													<option>Select Sub-categories </option>
													<option>Select Sub-categories </option>
												</select>
											</div>
										</div>
										<hr />
										<div className="col-md-6">
											<div className="files_flex">
												<div className="custom-file">
													<label>Add Pictures</label>
													<input
														type="text"
														placeholder="Upload pictures"
														className="form-control"
													/>
													<input
														type="file"
														className="custom-file-input"
														id="attachments"
														multiple
														onChange={updateList}
													/>
												</div>
												<ul id="fileList" className="file-list"></ul>
											</div>
										</div>
										<div className="col-md-6">
											<div className="files_flex">
												<div className="custom-file">
													<label>Add Thumbnail</label>
													<input
														type="text"
														placeholder="Upload pictures"
														className="form-control"
													/>
													<input
														type="file"
														className="custom-file-input"
														id="attachments-two"
														multiple
														onChange={updateListtwo}
													/>
												</div>
												<ul id="fileList-two" className="file-list"></ul>
											</div>
										</div>
										<hr />
										<div className="col-md-6">
											<div className="form-group">
												<label htmlFor="UnitPrice">Unit Price</label>
												<input
													type="number"
													placeholder="00"
													className="form-control"
													id="UnitPrice"
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label htmlFor="PurchasePrice">Purchase Price</label>
												<input
													type="number"
													placeholder="00"
													className="form-control"
													id="PurchasePrice"
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label htmlFor="discount">Discount</label>
												<input
													type="number"
													placeholder="00"
													className="form-control"
													id="discount"
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label htmlFor="quantity">Quantity</label>
												<input
													type="number"
													placeholder="00"
													className="form-control"
													id="quantity"
												/>
											</div>
										</div>
										<hr />

										<div className="col-md-12">
											<div className="text-editor">
												<label>Product Details</label>
												<textarea
													name=""
													placeholder=""
													className="form-control"
													id=""
													cols="30"
													rows="10"
												></textarea>
											</div>
										</div>
										<div className="col-md-12">
											<div className="bottom_bar">
												<div className="form-check">
													<input
														className="form-check-input"
														type="checkbox"
														value=""
														id="flexCheckChecked1"
														checked
													/>
													<label
														className="form-check-label"
														htmlFor="flexCheckChecked1"
													>
														I Confirm that the product and it specifications are
														correct and same as product
													</label>
												</div>
												<div className="button-group">
													<button className="btn">Submit</button>
													<button className="btn">Cancel</button>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_add_product;
